/**
 * Pending Advisor Question — one-tap retry after upgrade.
 *
 * When a Pro user taps the "Explore Premium — Portfolio-Aware AI" nudge
 * chip below an Advisor reply, we save the *original* portfolio question
 * (plus the deal it was asked about) to localStorage. After they check
 * out on Stripe and return, the Advisor auto-restores + auto-sends that
 * question as their first Premium query — no re-typing needed.
 *
 * TTL: 30 minutes so an abandoned checkout doesn't ambush the user weeks
 * later with a stale question.
 */
export const PENDING_KEY = 'rp_advisor_pending_upgrade';
export const TTL_MS = 30 * 60 * 1000; // 30 minutes

const _now = () => Date.now();

export function savePendingQuestion({ question, dealId, address }) {
  if (!question || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      PENDING_KEY,
      JSON.stringify({
        question,
        dealId: dealId || null,
        address: address || null,
        savedAt: _now(),
      }),
    );
  } catch {
    // localStorage may be unavailable (SSR, private mode). No-op is fine —
    // upgrade still works, just without the auto-retry.
  }
}

export function readPendingQuestion() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.question || !parsed?.savedAt) return null;
    if (_now() - parsed.savedAt > TTL_MS) {
      window.localStorage.removeItem(PENDING_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingQuestion() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(PENDING_KEY);
  } catch {
    // no-op
  }
}
